<template>
<div>
  <header class="top">
    <div class="top-cont">
      <a
        class="logo nav-mobile-hide"
        onClick="gtag('event', 'LOGO', {'event_category' : '导航栏', 'event_label' : 'click1'});"
        href="https://ai.arcsoft.com.cn"
        title="虹软"
      ></a>
      <a
        class="login-icon-mobile"
        onclick="gtag('event', '登录图标', {'event_category' : '手机端-导航栏', 'event_label' : 'mobile-button07'})"
        href="/ucenter/resource/build/index.html#/login"
        ><img src="/resource/images/logining-icon.png" alt=""
      /></a>
      <div class="list-nav-cont nav-mobile-hide">
        <ul>
          <template v-for="value in navList">
            <li :key="value.id">
              <a
                :data-href="value.dataHref || ''"
                :href="value.children.length === 0 ? value.url : 'javascript:void(0);'"
                @click="handleNavClick(value)"
                >{{ value.label }}</a
              >
              <sup v-if="value.id === 6" style="margin-left: 4px"
                ><img src="/resource/images/new_nav.png" alt=""
              /></sup>
              <div
                class="li-cont"
                v-if="value.children.length > 0"
                :style="'width:' + value.width"
              >
                <div :class="'wrap-all ' + value.direction">
                  <div
                    class="wrap-box"
                    v-for="wrapBox in value.children"
                    :key="wrapBox.id"
                  >
                    <div
                      class="item"
                      v-for="item in wrapBox.children"
                      :key="item.id"
                    >
                      <p class="title">{{ item.label }}</p>
                      <div class="content">
                        <p v-for="itemCont in item.children" :key="itemCont.id">
                          <a
                            v-for="third in itemCont.children"
                            :key="third.id"
                            @click="handleNavClick(third)"
                            :href="third.url"
                            v-html="`<i>›</i>${third.label}`"
                            :style="`width:${itemCont.children.length>1?'50%':'100%'}`"
                            >
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </template>
          <li class="beforeUserLogin" style="display: inline-block">
            <a
              class="developer-center"
              href="/ucenter/resource/build/index.html#/index"
              onclick="gtag('event', '开发者中心', {'event_category' : '导航栏', 'event_label' : 'click31'});"
              >开发者中心</a
            >
          </li>
          <li class="afterUserLogin" style="display: none">
            <div class="developer-user">
              <p class="login-icon">
                <a
                  class="developer-user-center"
                  href="/ucenter/resource/build/index.html#/index"
                  onclick="gtag('event', '开发者中心', {'event_category' : '导航栏', 'event_label' : 'click31'});"
                  >开发者中心</a
                >
              </p>
              <dl>
                <dd class="userinfo-name">
                  <a
                    href="/ucenter/resource/build/index.html#/account"
                    onclick="gtag('event', '开发者中心-用户名', {'event_category' : '导航栏', 'event_label' : 'click32'});"
                  ></a>
                </dd>
                <dd class="userinfo-account">
                  <a
                    href="/ucenter/resource/build/index.html#/accountMiddle?from=account"
                    onclick="gtag('event', '开发者中心-认证', {'event_category' : '导航栏', 'event_label' : 'click33'});"
                  ></a>
                </dd>
                <dd class="userinfo-link">
                  <a
                    href="/ucenter/resource/build/index.html#/account"
                    onclick="gtag('event', '开发者中心-个人信息', {'event_category' : '导航栏', 'event_label' : 'click34'});"
                    >个人信息</a
                  >
                </dd>
                <dd class="logout">退出登录</dd>
              </dl>
            </div>
          </li>
        </ul>
        <div class="menu"></div>
      </div>
    </div>

    <nav class="top-nav">
      <div class="nav-close-cont">
        <img class="mobile-nav-btn" src="/resource/images/mobile-nav-btn.png" />
      </div>
      <ul>
        <li>
          <div class="nav-two technology">
            <template v-for="(value,index) in navList">
              <template v-if="value.children.length > 0">
              <dl
                :key="value.id"
                class="technology-middle"
              >
                <dt @click="handleDtClick(index)">
                  <a href="#">{{ value.label }}</a>
                </dt>
                <template v-for="proGrandFa in value.children">
                    <dd v-for="proFa in proGrandFa.children" :key="proFa.id">
                      <a class="nav-indent-title">{{ proFa.label }}</a>
                      <a
                        v-for="proChild in proFa.mbChildren"
                        :key="proChild.id"
                        :href="proChild.url"
                        class="nav-indent"
                        @click="handleNavClick(proChild)"
                        v-html="`<i>›</i>${proChild.label}`"
                      >
                      </a>
                    </dd>
                </template>
              </dl>
              </template>
              <dl v-else :key="value.id">
                <a
                  :href="value.url"
                  style="
                    display: inline-block;
                    width: 100%;
                    line-height: 40px;
                    padding-left: 60px;
                    font-weight: 700;
                  "
                  @click="handleNavClick(value)"
                  >{{ value.label }}</a
                >
              </dl>
            </template>
          </div>
        </li>
      </ul>
    </nav>
  </header>
  </div>
</template>

<script>
import $ from "jquery";
// import { gtag } from "../utils/gtag";
export default {
  name: "Nav",
  data() {
    return {
      navList: [],
      flag:true
    };
  },
  mounted() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());
    if (document.location.href.indexOf("ai.arcsoft.com.cn") > 0) {
      gtag("config", "UA-7959274-33");
    } else {
      gtag("config", "UA-7959274-34");
    }
    
    let more1 = true;
    $(".technology-middle dt").click(function () {
      console.log("hhhhh",this);
      if (more1) {
        $(this).siblings("dd").show();
        $(this).addClass("less");
        more1 = false;
      } else {
        $(this).siblings("dd").hide();
        $(this).removeClass("less");
        more1 = true;
      }
    });

    // var more = true;
    $(window).scroll(function () {
      if ($(window).scrollTop() >= 80) {
        $(".top").addClass("active");
        $(".logo").removeClass("nav-mobile-hide");
        $(".header-title").removeClass("nav-mobile-hide");
      } else {
        $(".top").removeClass("active");
        $(".logo").addClass("nav-mobile-hide");
        $(".header-title").addClass("nav-mobile-hide");
      }
    });
    $(".menu").click(function () {
      $(".top-nav").show();
      $(".mobilemenu-screen").css({ display: "block", "z-index": "9999" });

      var top = $(document).scrollTop(); //滚动条禁用，画面不变
      $(document).on("scroll.unable", function () {
        $(document).scrollTop(top);
      });
    });
    $(".mobile-nav-btn").click(function () {
      $(".top-nav").hide();
      $(".mobilemenu-screen").css({ display: "none", "z-index": "-1" });

      $(document).unbind("scroll.unable");
      // $("html, body").css("overflowY", "auto");
    });
    $(".mobilemenu-screen").click(function () {
      $(".mobile-nav-btn").trigger("click");
    });
    $(window).resize(function () {
      var wd = $(window).height();
      $(".top-nav").css({ height: wd, overflowY: "auto" });
    });
    $(".mobilemenu-screen").click(function () {
      $(".top-nav").hide();
      $(".mobilemenu-screen").css({ display: "none", "z-index": "-1" });
      $("html, body").css("overflowY", "auto");
    });
    var wd = $(window).height();
    $(".top-nav").css({ height: wd });
    const _this = this;
    $.get("/resource/js/nav.json?timestamp=" + new Date().getTime(), function (e) {
      _this.navList = e;
    });
    
    //登出
    $(".logout").click(function () {
      $.get("/ucenter/user/newlogout", function () {
        gtag("event", "开发者中心-退出登录", {
          event_category: "导航栏",
          event_label: "click35",
        });
        localStorage.setItem("userName", undefined);
        localStorage.setItem("password", undefined);
        window.location.replace("/ucenter/resource/build/index.html#/login");
      });
    });
  },
  methods: {
    handleNavClick(value) {
    gtag("event", value.gtagName, {
      event_category: "导航栏",
      event_label: value.gtagClick,
    });
  },
  handleDtClick(index){
      if (this.flag) {
        $(`.technology-middle:nth-child(${index+1}) dt`).siblings("dd").show();
        $(`.technology-middle:nth-child(${index+1}) dt`).addClass("less");
        this.flag = false;
      } else {
         $(`.technology-middle:nth-child(${index+1}) dt`).siblings("dd").hide();
         $(`.technology-middle:nth-child(${index+1}) dt`).removeClass("less");
        this.flag = true;
      }
  }
  },
  
};
</script>
<style scoped>
@charset "utf-8";

@keyframes liAni {
  from {
    top: 15px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
  
}
/*头部导航*/
.top {
  width: 100%;
  height: 79px;
  border-bottom: 1px solid transparent;
  position: fixed;
  top: 0;
  z-index: 9999;
}

.top.active {
  background-color: #fff;
  border-bottom: thin solid rgb(204, 204, 204);
}

.top:hover {
  opacity: 1;
}

.top-cont {
  width: 100%;
  margin: 0 auto;
}

.logo {
  display: inline-block;
  float: left;
  width: 250px;
  height: 33px;
  margin-top: 18px;
  margin-left: 40px;
  background: url(/resource/images/logo-ai2.svg) center center no-repeat;
  background-size: 250px 33px;
}

.active .logo {
  background: url(/resource/images/logo-ai.svg) center center no-repeat;
  background-size: 250px 33px;
}

.header-title {
  position: absolute;
  left: 190px;
  bottom: 28px;
  margin: 0 10px;
  line-height: 18px;
  font-size: 18px;
  color: #fff;
}

.header-title:before {
  content: "";
  display: inline-block;
  border-right: 1px solid #fff;
  height: 18px;
  margin-right: 10px;
  vertical-align: bottom;
}

.active .header-title {
  color: #000;
}

.active .header-title:before {
  border-right: 1px solid #000;
}

.logo:hover {
  opacity: 1;
}

.top-nav {
  position: fixed;
  top: 0;
  right: 0;
  width: 400px;
  z-index: 9999999;
  background-color: #fff;
  display: none;
  overflow-y: scroll;
}

.nav-close-cont {
  height: 40px;
}

.mobile-nav-btn {
  width: 15px;
  height: 15px;
  cursor: pointer;
  float: right;
  margin: 12px 17px 0 0;
  opacity: 0.7;
}

.mobile-nav-btn:hover {
  opacity: 1;
}

.top-nav ul {
  border-top: 1px solid #f2f2f2;
}

.top-nav a {
  text-decoration: none;
}

.top-nav ul li > a {
  line-height: 40px;
  padding-left: 30px;
}

.top-nav ul li > a:hover {
  color: #a00f13;
  font-weight: 700;
}

.top-nav .nav-two dt {
  line-height: 40px;
  padding-left: 60px;
  background: url(/resource/images/more.png) 90% center no-repeat;
  background-size: 16px 8px;
  cursor: pointer;
}

.top-nav .nav-two dt.less {
  background: url(/resource/images/less.png) 90% center no-repeat;
  background-size: 16px 8px;
}

.top-nav .nav-two dt a {
  font-weight: 700;
}

.top-nav a {
  color: #333;
  font-size: 13px;
  text-decoration: none;
}

.top-nav .nav-two dt.less a {
  color: #a00f13;
}

.top-nav .nav-two dd {
  line-height: 40px;
  padding-left: 90px;
  display: none;
}
.top-nav .nav-two dd a:not(.nav-indent-title) {
  line-height: 40px;
  display: block;
}
.top-nav .nav-two dd:hover {
  display: block;
  background: rgb(249, 249, 249);
  color: rgb(228, 21, 63);
}

.top-nav .nav-two dd i {
  font-style: normal;
  margin-right: 5px;
  font-size: 20px;
}

.top-nav .nav-two .nav-indent-title {
  color: #333;
  font-weight: 700;
}

.top-nav .nav-two .nav-indent {
  padding-left: 20px;
}

.top-cont .languageBox .active {
  color: #e4153f;
}

.top-cont .languageBox {
  position: absolute;
  right: 60px;
  top: 20px;
  opacity: 0.7;
}

.top-cont .languageBox:hover {
  opacity: 1;
}

.menu {
  width: 28px;
  height: 28px;
  cursor: pointer;
  position: absolute;
  top: 25px;
  right: -53px;
  background: url(/resource/images/menu.png) center center no-repeat;
  display: none;
}

.top.active .menu {
  background: url(/resource/images/menu-active.png) center center no-repeat;
}

.menu img {
  width: 100%;
}

.mobilemenu-screen {
  background: rgba(0, 0, 0, 0.5) 0 0;
  display: none;
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: -1;
  will-change: transform;
}

.list-nav-cont {
  height: 79px;
  text-align: right;
  /*width: 75%;*/
  font-size: 14px;
  font-weight: bold;
  position: absolute;
  right: 0;
  float: right;
  margin-right: 18px;
}

.list-nav-cont.fixed {
  position: fixed;
  top: 0;
  z-index: 999999;
}

.list-nav-cont ul {
  display: inline-block;
  line-height: 79px;
}

.list-nav-cont li {
  position: relative;
  display: inline-block;
  margin: 0 17px;
  /* vertical-align: top; */
}

.list-nav-cont li.beforeUserLogin {
  margin-right: 0;
}

.list-nav-cont li > a {
  font-size: 14px;
  color: #fff;
  font-weight: 700;
  display: inline-block;
  line-height: 30px;
  height: 30px;
  cursor: pointer;
  text-decoration: none;
}

.active .list-nav-cont li > a {
  color: rgb(85, 85, 85);
  text-decoration: none;
}

.list-nav-cont li > a:hover {
  border-bottom: 2px solid #bf0000;
}

.list-nav-cont li:not(.afterUserLogin):hover dl {
  display: block;
}
.list-nav-cont li:not(.afterUserLogin):hover .li-cont {
  display: block;
}
.list-nav-cont li dl dd {
  position: relative;
  /* top: 15px; */
  top: 0;
}

.list-nav-cont li a.active {
  color: #e4153f;
}

.list-nav-cont li dl {
  position: absolute;
  /*left: -50px;*/
  background-color: #f5f5f5;
  z-index: 99;
  width: 120px;
  display: none;
  text-align: left;
  font-weight: 300;
  /*	box-shadow: 0px 0px 3px 1px #c5c6cb;*/
  top: 79px;
  font-size: 0;
  padding-left: 20px;
  padding-bottom: 10px;
}

.list-nav-cont li dl .dl-nac-cont-item {
  display: inline-block;
  vertical-align: top;
}

.list-nav-cont li dl .dl-nac-cont-item .dl-item-title {
  font-size: 16px;
  line-height: 34px;
  border-bottom: 2px solid #ccc;
  color: #333;
  font-weight: 700;
}

.list-nav-cont li dl .dl-nac-cont-item + .dl-nac-cont-item .dl-item-title,
.list-nav-cont li dl .dl-nac-cont-item + .dl-nac-cont-item dd {
  padding-left: 30px;
}

.list-nav-cont2 {
  width: 140px !important;
}

.list-nav-cont3 {
  width: 380px !important;
  left: -180px;
}

.list-nav-cont li dl dd {
  line-height: 36px;
  /* opacity:0;
    top: 15px;
    transition: all 0.3s linear 0.5s; */
}

/* .list-nav-cont li:hover dl dd{
	opacity:1;
	top: 0;
} */
.list-nav-cont li dl dd a {
  color: #000;
  text-decoration: none;
  font-size: 14px;
  /* width: 90%; */
  line-height: 32px;
  display: inline-block;
  vertical-align: top;
}

.list-nav-cont li dl dd a:hover {
  color: #bf0000;
}

.list-nav-cont li dl dd a i {
  margin-right: 5px;
  font-size: 20px;
  font-style: normal;
  padding-top: 12px;
  /*vertical-align:bottom;*/
}

.list-nav-cont li dl dd a:hover {
  color: rgb(142, 16, 17);
}

.list-nav-cont li .developer-center {
  background: #bf0000 url(/resource/images/center.png) 10px center no-repeat;
  display: inline-block;
  padding: 0 10px 0 30px;
  color: #fff;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 300;
}

.list-nav-cont li.afterUserLogin {
  display: none;
}

.top.active .list-nav-cont li .developer-center {
  color: #fff;
}

.top .list-nav-cont li .developer-center:hover {
  border: none;
  background-color: #a70101;
}

.list-nav-cont li .developer-center-reg {
  display: inline-block;
  padding: 0 20px;
  background-color: #bf0000;
  color: #fff;
  border-radius: 2px;
  margin-left: 20px;
}

.active .list-nav-cont li > a.developer-center-reg {
  color: #fff;
}

.list-nav-cont li .developer-center-reg:hover {
  border: none;
  background-color: #a70101;
}

.list-nav-cont li .developer-user {
  display: inline-block;
  vertical-align: middle;
  margin-left: 25px;
  position: relative;
}

.list-nav-cont li .developer-user .login-icon {
  width: 80px;
  height: 79px;
  background: url(/resource/images/login-icon.png) left center no-repeat;
  cursor: pointer;
  padding-left: 36px;
}

.list-nav-cont li .developer-user dl {
  border-radius: 3px;
  left: auto;
  right: 0;
}

.list-nav-cont li .developer-user:hover dl {
  display: block;
}

.list-nav-cont li .developer-user dl dd {
  padding-left: 30px;
  font-size: 14px;
}

.list-nav-cont li .developer-user dl .userinfo-name {
  width: calc(100% - 40px);
  background: url(/resource/images/userinfo-name.png) left center no-repeat;
}
.list-nav-cont li .developer-user dl .userinfo-name a {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.list-nav-cont li .developer-user dl .userinfo-account.account-ok {
  background: url(/resource/images/account-ok.png) left center no-repeat;
}

.list-nav-cont li .developer-user dl .userinfo-account.accounting {
  background: url(/resource/images/accounting.png) left center no-repeat;
}

.list-nav-cont li .developer-user dl .userinfo-account.account-no {
  background: url(/resource/images/account-no.png) left center no-repeat;
}

.list-nav-cont li .developer-user dl .userinfo-link {
  padding-left: 0;
}

.list-nav-cont li .developer-user dl .userinfo-link {
  padding-left: 30px;
  display: block;
  background: url(/resource/images/userinfo-link.png) left center no-repeat;
}

.list-nav-cont li .developer-user dl .userinfo-link:hover {
  color: #bf0000;
  background: url(/resource/images/userinfo-link-active.png) left center
    no-repeat;
}

/* .list-nav-cont li .developer-user dl .userinfo-link a {
    padding-left: 30px;
    display: block;
    background: url(/resource/images/userinfo-link.png) left center no-repeat;
}

.list-nav-cont li .developer-user dl .userinfo-link:hover a {
    color: #BF0000;
    background: url(/resource/images/userinfo-link-active.png) left center no-repeat;
} */

.list-nav-cont li .developer-user dl .logout {
  background: url(/resource/images/logout.png) left center no-repeat;
  cursor: pointer;
}

.list-nav-cont li .developer-user dl .logout:hover {
  color: #bf0000;
  background: url(/resource/images/logout-active.png) left center no-repeat;
}

.list-nav-cont li .developer-user .developer-user-center {
  color: #fff;
}

.list-nav-cont .solution-1 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 15px;
  margin-bottom: 15px;
  padding-left: 10px;
}

/* .list-nav-cont .solution-1 dd{
    width: 140px;
} */

/* .list-nav-cont .solution-1 dd:nth-child(1){
  width: 170px;
} */
.list-nav-cont .solution-1 dd:nth-child(2) {
  width: 150px;
  margin-left: -90px;
}
/* .list-nav-cont .solution-1 dd:nth-child(3){
  width: 170px;
} */
.list-nav-cont .solution-1 dd:nth-child(4) {
  width: 150px;
}

.list-nav-cont .solution-1 dd:nth-child(5) {
  width: 170px;
}

.list-nav-cont .solution-2 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 15px;
  padding-left: 10px;
}

.list-nav-cont .solution-3 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-top: 15px;
  margin-bottom: 15px;
  padding-left: 20px;
}

.list-nav-cont .solution-2 dd {
  width: 140px;
}

.list-nav-cont .solution-2 dd:nth-child(1),
.list-nav-cont .solution-2 dd:nth-child(3),
.list-nav-cont .solution-2 dd:nth-child(5) {
  width: 210px;
}
.list-nav-cont .solution-2 dd:nth-child(4) {
  width: 149px;
}

.list-nav-cont .title2 {
  font-size: 14px;
  font-weight: 700;
  line-height: 19px;
  color: #000000;
}

.list-nav-cont .title1 {
  font-size: 14px;
  font-weight: 700;
  line-height: 19px;
  color: #000000;
}

.top.active .list-nav-cont li .developer-user .developer-user-center {
  color: rgb(85, 85, 85);
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

.login-icon-mobile {
  position: absolute;
  right: 68px;
  top: 10px;
  display: none;
}

.login-icon-mobile img {
  width: 30px;
  height: 30px;
}

@media screen and (max-width: 1200px) {
  .list-nav-cont {
    margin-right: 78px;
  }

  .nav-mobile-hide ul {
    display: none;
  }

  .menu {
    display: block;
  }
}

@media screen and (min-width: 981px) {
  .nav-mobile-hide {
    display: inline-block;
  }
}

@media screen and (max-width: 640px) {
  .login-icon-mobile {
    display: block;
  }

  .top {
    height: 50px;
  }

  .top-nav {
    width: 100%;
  }

  .header-title {
    display: none;
  }

  .logo {
    margin: 10px;
    background-size: 100%;
    background-position: left;
    width: 125px;
  }

  .active .logo {
    margin: 10px;
    background-size: 100%;
    background-position: left;
    width: 125px;
  }

  .menu {
    top: 10px;
    right: -65px;
  }

  .logo {
    background-position: left;
  }
}

.solution-first,
.example,
.help,
.application {
  padding-top: 15px;
}

.list-nav-cont li .li-cont {
  display: none;
}
.list-nav-cont li .li-cont {
  position: absolute;
  background-color: #f5f5f5;
  z-index: 99;
  width: 350px;
  display: none;
  text-align: left;
  font-weight: 300;
  top: 79px;
  padding: 15px 30px 10px 20px;
}
.list-nav-cont li:nth-child(2) .li-cont {
  width: 776px;
}
.list-nav-cont li:nth-child(3) .li-cont {
  width: 332px;
  padding-right: 0;
}
.list-nav-cont li:nth-child(4) .li-cont,
.list-nav-cont li:nth-child(8) .li-cont {
  width: 120px;
  padding-right: 0;
}
.list-nav-cont li .li-cont .wrap-all {
  position: relative;
  animation: liAni .3s linear;
}
.list-nav-cont li .li-cont .wrap-all.horizontal {
  display: flex;
}

.list-nav-cont li:nth-child(2) .li-cont .wrap-box {
  width: 184px;
}

.list-nav-cont li .li-cont .item .title {
  font-size: 14px;
  font-weight: 700;
  line-height: 19px;
  color: #000000;
}
.list-nav-cont li .li-cont .item .content {
  margin-top: 15px;
  margin-bottom: 15px;
  padding-left: 10px;
}
.list-nav-cont li:nth-child(2) .li-cont {
  padding-left: 0;
  padding-right: 0;
}
.list-nav-cont li:nth-child(2) .li-cont .item {
  margin-left: 20px;
}
.list-nav-cont li .li-cont .wrap-all.column .item:last-child .content {
  margin-bottom: 0;
}
.list-nav-cont li:nth-child(2) .li-cont .wrap-box:nth-child(1) .content,
.list-nav-cont li:nth-child(2) .li-cont .wrap-box:nth-child(4) .content {
  margin-bottom: 0;
}
.list-nav-cont li:nth-child(4) .li-cont .content,
.list-nav-cont li:nth-child(8) .li-cont .content {
  margin-top: 0;
  padding-left: 0;
}
.list-nav-cont li .li-cont .item .content > p {
  display: flex;
  justify-content: space-between;
  line-height: 36px;
  margin-bottom: 0;
}
.list-nav-cont .li-cont .item .content > p a {
  color: #000;
  text-decoration: none;
  font-size: 14px;
  line-height: 33px;
  display: inline-block;
  vertical-align: top;
}
.list-nav-cont .li-cont .item .content > p a:hover {
  color: rgb(142, 16, 17);
}

.list-nav-cont .li-cont .item .content > p a i {
  margin-right: 5px;
  font-size: 20px;
  font-style: normal;
  padding-top: 12px;
}

.list-nav-cont li:nth-child(1) .li-cont .item .content > p a b {
  color: #bf0000;
  height: 12px;
  font-size: 12px;
  line-height: 20px;
  font-weight: normal;
  position: relative;
  left: 8px;
}
.list-nav-cont li:nth-child(1) .li-cont .item .content > p a b[data-yellow] {
  color: #ffa500;
}
.list-nav-cont li:nth-child(1) .li-cont .item .content > p a b[data-red] {
  color: #bf0000;
}
.list-nav-cont li:nth-child(1) .li-cont .item .content > p a b[data-green] {
  color: #00db5f;
}



</style>

<style>
.list-nav-cont .li-cont .item .content > p a i {
  margin-right: 5px;
  font-size: 20px;
  font-style: normal;
  padding-top: 12px;
}

.list-nav-cont li:nth-child(1) .li-cont .item .content > p a b {
  color: #bf0000;
  height: 12px;
  font-size: 12px;
  line-height: 20px;
  font-weight: normal;
  position: relative;
  left: 8px;
}
.list-nav-cont li:nth-child(1) .li-cont .item .content > p a b[data-yellow] {
  color: #ffa500;
}
.list-nav-cont li:nth-child(1) .li-cont .item .content > p a b[data-red] {
  color: #bf0000;
}
.list-nav-cont li:nth-child(1) .li-cont .item .content > p a b[data-green] {
  color: #00db5f;
}
.top-nav .nav-two dd i {
  font-style: normal;
  margin-right: 5px;
  font-size: 20px;
}
</style>
